const LEADING_NUMBER = /^(\d+)(.*)$/;
// "257", "1a", "7/9", "13-15", "24a/2b" - what a typed token has to look like to be read as a building number.
const HOUSE_NUMBER_TOKEN = /^\d+[a-z]?([/-]\d+[a-z]?)?$/i;

const suffixCollator = new Intl.Collator("pl", {numeric: true, sensitivity: "base"});

/** Natural order of RCN building numbers: 1, 1A, 3, 5, 7/9, 10; numbers without leading digits go last. */
export const compareHouseNumbers = (a: string, b: string): number => {
    const matchA = LEADING_NUMBER.exec(a.trim());
    const matchB = LEADING_NUMBER.exec(b.trim());

    if (matchA && matchB) {
        return Number(matchA[1]) - Number(matchB[1]) || suffixCollator.compare(matchA[2], matchB[2]);
    }
    if (matchA || matchB) {
        return matchA ? -1 : 1;
    }

    return suffixCollator.compare(a, b);
};

export const isHouseNumberToken = (token: string): boolean => HOUSE_NUMBER_TOKEN.test(token);

/** "257" matches "25", "7/9" matches "7"; case-insensitive. */
export const houseNumberStartsWith = (houseNumber: string, token: string): boolean => houseNumber.trim().toLowerCase().startsWith(token.trim().toLowerCase());
const LEADING_NUMBER = /^(\d+)(.*)$/;
// "257", "1a", "7/9", "13-15", "24a/2b" - what a typed token has to look like to be read as a building number.
const HOUSE_NUMBER_TOKEN = /^\d+[a-z]?([/-]\d+[a-z]?)?$/i;

const suffixCollator = new Intl.Collator("pl", {numeric: true, sensitivity: "base"});

/** Natural order of RCN building numbers: 1, 1A, 3, 5, 7/9, 10; numbers without leading digits go last. */
export const compareHouseNumbers = (a: string, b: string): number => {
    const matchA = LEADING_NUMBER.exec(a.trim());
    const matchB = LEADING_NUMBER.exec(b.trim());

    if (matchA && matchB) {
        return Number(matchA[1]) - Number(matchB[1]) || suffixCollator.compare(matchA[2], matchB[2]);
    }
    if (matchA || matchB) {
        return matchA ? -1 : 1;
    }

    return suffixCollator.compare(a, b);
};

export const isHouseNumberToken = (token: string): boolean => HOUSE_NUMBER_TOKEN.test(token);

/** "257" matches "25", "7/9" matches "7"; case-insensitive. */
export const houseNumberStartsWith = (houseNumber: string, token: string): boolean => houseNumber.trim().toLowerCase().startsWith(token.trim().toLowerCase());
